import React from "react";
import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn } from "react-icons/fa";
export default function TopScrollingText() {
    return (
        <div className="marquee-wrapper">
            <div className="social-icons">
                <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
                <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
                <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
                <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
            </div>
            <div class="marquee">
                <div class="marquee-track">
                    <span>Minimum 2 pieces (You can mix any Pattern / Models) for an order, 360° opening video must for any sort of complaint, Customer care : 9360990836</span>
                    {/* <span>Minimum 2 pieces (You can mix any Pattern / Models) for an order, 360° opening video must for any sort of complaint, Customer care : 9360990836</span> */}
                    {/* <span>Minimum 2 pieces (You can mix any Pattern / Models) for an order, 360° opening video must for any sort of complaint, Customer care : 9360990836</span> */}
                </div>
            </div>
        </div>
    );
}